import { createSlice } from 'utils/@reduxjs/toolkit';
import { GasketsState } from './types';
import { reducers } from './reducers';

export const initialState: GasketsState = {
  isLoading: false,
  error: null,
  data: null,
  showPriceResults: false,
};

const slice = createSlice({
  name: 'gaskets',
  initialState,
  reducers,
});

export const { actions: gasketsActions } = slice;
export const { reducer: gasketsReducer } = slice;
